import { Form, Mentions, Select, Switch } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { getFiles } from '../../../../services/assistant'
import { InputSearch } from '../../../input-search'
import { EnterOutlined } from "@ant-design/icons";

const modes = [
  {
    label: "Botões com AI",
    value: "AI_BUTTONS"
  },
  {
    label: "Botões fixos",
    value: "BUTTONS"
  }
]

export default function SendButton({ fieldName, parameters, form }) {
  const mode = Form.useWatch(['actions', fieldName, 'action', 'data', 'mode'], form)

  const availableArrayString = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item name={[fieldName, 'action', 'data', 'mode']}
        initialValue={'BUTTONS'}
        label={'Modo dos botões'}>
        <Select options={modes} placement={"Selecione o modo de botões"} />
      </Form.Item>
      {mode === 'BUTTONS' && <Form.Item
        label={'Botões fixos'}
        rules={[
          {
            required: true,
            message: "É obrigatório adicionar pelo menos uma opção.",
          },
          {
            validator: (_, value) => {
              if (value && value.some(v => v.length > 20)) {
                return Promise.reject(new Error('Cada botão deve ter no máximo 20 caracteres'));
              }
              return Promise.resolve();
            }
          }
        ]}
        validateTrigger={['onChange', 'onBlur']}
        name={[fieldName, 'action', 'data', 'buttons']}>
        <Select
          mode="tags"
          open={false}
          maxCount={3}
          suffixIcon={<EnterOutlined />}
          placeholder="Digite o conteúdo do botão e dê enter em seguida"
        />
      </Form.Item>}
      {mode === 'AI_BUTTONS' && <Form.Item
        label={'Botões gerados por AI'}
        name={[fieldName, 'action', 'data', 'aiButtons']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString} />
      </Form.Item>}
    </>
  )
}
